module.exports = __webpack_public_path__ + "img/portrait-081.9ec7b361.jpg";